import React, { Component } from "react";
import { Container, Header, Footer, Card, Accordion, AccordionItem } from '@deere/ux.uxframe-react';
import CompanyTopHeader from './company-top-header';
import CommoditiesSummary from '../../commodities-services/components/commodities-summary';
import Button from "../../reusable/components/Button.jsx";
import TextArea from '../../reusable/components/TextArea';
import { Modal } from '@deere/ux.uxframe-react';
import CompanyStatus from "./company-status";
import FinacialSummary from '../../diversity-finacial/finacial-summary.jsx';
import DiversitySummary from '../../diversity-finacial/diversity-summary';
import AuditSummary from '../../audit/audit-summary';
import ServiceDownError from "../../reusable/components/ServiceDownError";
import CommentComponent from '../../comments/components/create-comments.jsx';
import SuccessMsg from "../../reusable/components/SuccessMessage.jsx";
import baseurl from '../../api-properties';
import { isMobile } from 'react-device-detect';

if (isMobile) {
    import('../../mobileindex.css').then(() => {});
} else {
    import('../../index.css').then(() => {});
}


class Deeresummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            render: false,
            readOnlySubmitBtn: true,
            prosNumber: this.props.match.params.value1,
            prosSuppId: 0,
            loginBy: this.props.match.params.value2,
            companyInfo: [],
            displayDiversityInfoJson: false,
            diversityInfoJson: [],
            auditInfoJson: [],
            displayFinacialInfoJson: false,
            finacialInfoJson: [],
            displayCommoditiesInfoJson: false,
            commoditiesInfoJson: [],
            isSupplierServiceDown: true,
            isCommodityServiceDown: true,
            isFinancialServiceDown: true,
            isCommentServiceDown: true,
            isDiversityServiceDown: true,
            isAuditServiceDown: true,
            commentsInfo: [],
            commentCount: 0,
            successMsg: "",
            errorMsg: "",
            displayActionComment: false,
            actionStatus: "",
            actionComment: "",
            actionCommentErrorMessage: "",
            headerComment: ""
        };
        this.updateSupplierStatus = this.updateSupplierStatus.bind(this);
        this.handleNotInterest = this.handleNotInterest.bind(this);
        this.handleOnHold = this.handleOnHold.bind(this);
        this.handleStartSPR = this.handleStartSPR.bind(this);
        this.setRenderData = this.setRenderData.bind(this);
        this.cancelActionComment = this.cancelActionComment.bind(this);
        this.saveActionComment = this.saveActionComment.bind(this);
        this.handleInput = this.handleInput.bind(this);
    }
    componentDidMount() {
        let prosNumber = this.state.prosNumber;
        this.loadSupplierDetails(prosNumber);
    }

    handleInput = (e) => {
        let value = e.target.value;
        let name = e.target.name;
        this.setState({ [name]: value });
    }

    loadSupplierDetails = (prosNumber) => {
        let loginBy = this.state.loginBy;
        fetch(baseurl.PROS_SUPPLIER_API_URL + "supllier/getSupplier/" + prosNumber + "/" + loginBy)
            .then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                if (response.status !== 204) {
                    this.state.isSupplierServiceDown = false;
                } return response.json();
            })
            .then(data => {
                if (data !== undefined && data !== null) {
                    let prosSuppId = data.prosSuppId;
                    this.state.isSupplierServiceDown = false;
                    this.setState({ companyInfo: data });
                    this.setState({ prosSuppId: prosSuppId });
                    if (data.diverseCert !== undefined && data.diverseCert !== null && data.diverseCert !== "")
                        this.setState({ displayDiversityInfoJson: true });
                    this.loadDiversityInfo(prosSuppId);
                }
            }).catch(error => {
                this.state.isSupplierServiceDown = false;
                console.log(error);
            });
    }

    loadDiversityInfo = (prosSuppId) => {
        fetch(baseurl.DIVERSITY_API_URL + "diversity/getCertifications/" + prosSuppId)
            .then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                if (response.status !== 204) {
                    this.state.isDiversityServiceDown = false;
                } return response.json();
            })
            .then(data => {
                if (data !== undefined && data !== null)
                    this.setState({ diversityInfoJson: data });
                this.state.isDiversityServiceDown = false;
                this.loadFinacialInfo(prosSuppId);
            }).catch(error => {
                this.state.isDiversityServiceDown = false;
                console.log(error);
            });
    }

    loadFinacialInfo = (prosSuppId) => {
        fetch(baseurl.FINACIAL_API_URL + "financial/getFinancial/" + prosSuppId)
            .then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                if (response.status !== 204) {
                    this.state.isFinancialServiceDown = false;
                } return response.json();
            })
            .then(data => {
                if (data !== undefined && data != null && data.isDataExist === true)
                    this.setState({ displayFinacialInfoJson: true, finacialInfoJson: data });
                this.state.isFinancialServiceDown = false;
                this.loadCommentDetails(prosSuppId);
            }).catch(error => {
                this.state.isFinancialServiceDown = false;
                console.log(error);
            });
    }

    loadCommentDetails = (prosSuppId) => {
        fetch(baseurl.COMMENT_API_URL + "comment/getComments/" + prosSuppId)
            .then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                if (response.status !== 204) {
                    this.state.isCommentServiceDown = false;
                    this.loadSupplierAudits(prosSuppId, true);
                } return response.json();
            })
            .then(data => {
                let count = 0;
                if (data !== undefined && data !== null && data.length > 0) {
                    let filteredData = data.filter(obj => obj.commentType === 'DC');
                    if (filteredData.length > 2) {
                        count = filteredData.length - 2;
                        this.setState({ commentsInfo: filteredData, commentCount: count });
                    } else {
                        this.setState({ commentsInfo: filteredData, commentCount: count });
                    }
                }
                this.state.isCommentServiceDown = false;
                this.loadSupplierAudits(prosSuppId, true);
            }).catch(error => {
                this.state.isCommentServiceDown = false;
                this.loadSupplierAudits(prosSuppId, true);
                console.log(error);
            });
    }

    loadSupplierAudits = (prosSuppId, loadNextFunction) => {
        fetch(baseurl.AUDIT_API_URL + "audit/getSupplierAudits/" + prosSuppId)
            .then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                if (response.status !== 204) {
                    this.state.isAuditServiceDown = false;
                } return response.json();

            })
            .then(data => {
                if (data !== undefined && data !== null)
                    this.setState({ auditInfoJson: data });
                this.state.isAuditServiceDown = false;
                if (loadNextFunction)
                    this.loadCommoditiesInfo(prosSuppId);
            }).catch(error => {
                this.state.isAuditServiceDown = false;
                console.log(error);
            });
    }

    loadCommoditiesInfo = (prosSuppId) => {
        fetch(baseurl.COMMODITY_API_URL + "commodity/getCommodity/" + prosSuppId)
            .then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                if (response.status !== 204) {
                    this.state.isCommodityServiceDown = false;
                    this.getHeaderComment();
                } return response.json();
            })
            .then(data => {
                if (data !== undefined && data !== null && data.length > 0)
                    this.setState({ displayCommoditiesInfoJson: true, commoditiesInfoJson: data });
                this.state.isCommodityServiceDown = false;
                this.getHeaderComment();
            }).catch(error => {
                this.state.isCommodityServiceDown = false;
                this.getHeaderComment();
                console.log(error);
            });
    }

    getHeaderComment = () => {
        let prosSuppId = this.state.prosSuppId;
        let commentType = "RC";
        if (this.state.companyInfo.status === 'N') {
            commentType = "NC";
        } else if (this.state.companyInfo.status === 'H') {
            commentType = "HC";
        }
        fetch(baseurl.COMMENT_API_URL + "comment/getCommentsByType/" + prosSuppId + "/" + commentType, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            if (response.status === 500 || response.status === 204) {
                this.getParamComment();
            } else return response.json();
        }).then(data => {
            if (data !== undefined && data !== null) {
                this.setState({ headerComment: data.comment });
            }
            if (this.state.headerComment === "") {
                this.getParamComment();
            } else {
                this.setRenderData();
            }
        }).catch(error => {
            console.log(error);
            this.setRenderData();
        });
    }

    getParamComment = () => {
        let jsonData = "APRV_CMNT";
        if (this.state.companyInfo.status === 'D') {
            jsonData = "SANC_F_CMNT";
        }
        fetch(baseurl.PROS_SUPNET_API_URL + "/ps/getParamsByCategory/categoryCd/localecd?categoryId=" + jsonData + "&localeCd=en_US", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            return response.json();
            //this.setRenderData();
        }).then(data => {
            if (data[0] !== undefined && data[0] !== null) {
                this.setState({ headerComment: data[0].description });
            }
            this.setRenderData();
        }).catch(error => {
            console.log(error);
            this.setRenderData();
        });
    }

    setRenderData() {
        this.setState({ render: true });
        (this.state.companyInfo.country !== 'US' ||
            this.state.displayDiversityInfoJson === true) &&
            this.state.displayFinacialInfoJson === true &&
            this.state.displayCommoditiesInfoJson === true ?
            this.setState({ readOnlySubmitBtn: false })
            : this.setState({ readOnlySubmitBtn: true })
    }

    // urlWithParams = (urlString, params = {}) => {
    //     var url = new URL(urlString);
    //     var searchParams = new URLSearchParams();
    //     Object.keys(params).forEach((key) => {
    //         searchParams.append(key, params[key]);
    //     });
    //     url.search = searchParams.toString();
    //     return url.toString();
    // }

    cancelActionComment() {
        this.setState({ displayActionComment: false });
        this.setState({ actionCommentErrorMessage: "" });
    }

    saveActionComment() {
        if (this.state.actionStatus.length > 0) {
            if (this.state.actionComment.length > 0) {
                let commentType = "NC"; // Not Interested Comments
                if (this.state.actionStatus === "H") {
                    commentType = "HC"; // HOLD Comments
                }
                this.saveComments(this.state.actionComment, commentType);
            } else {
                this.setState({ actionCommentErrorMessage: "Please enter a comment." });
            }
        }
    }

    handleNotInterest() {
        this.setState({ displayActionComment: true });
        this.setState({ actionStatus: "N" });
        this.setState({ actionComment: "" });
        this.setState({ actionCommentErrorMessage: "" });
    }

    handleOnHold() {
        this.setState({ displayActionComment: true });
        this.setState({ actionStatus: "H" });
        this.setState({ actionComment: "" });
        this.setState({ actionCommentErrorMessage: "" });
    }

    handleStartSPR(e) {
        e.preventDefault();
        this.updateSupplierStatus("A");
    }

    updateSupplierStatus(status) {
        let prosSuppId = this.state.prosSuppId;
        let prosNumber = this.state.prosNumber;
        let userData = { prosSuppId: prosSuppId, status: status };
        fetch(baseurl.PROS_SUPPLIER_API_URL + "supllier/updateSupplier", {
            method: "POST",
            body: JSON.stringify(userData),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            if (response.status === 204) {
            } else return response.json();
        }).then(() => {
            window.scrollTo(0, 0);
            this.loadSupplierDetails(prosNumber);
        }).catch(error => {
            console.log(error);
        });
    }

    saveComments = (value, commentType) => {
        let commentsEntered = value;
        let loginBy = this.state.loginBy;
        let prosSuppId = this.state.prosSuppId;
        let userData = { "prosSuppId": prosSuppId, "comment": commentsEntered, "commentType": commentType, "createdBy": loginBy };
        fetch(baseurl.COMMENT_API_URL + "comment/saveComments/", {
            method: "POST",
            body: JSON.stringify(userData),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            if (commentType === "HC" || commentType === "NC") {
                this.updateSupplierStatus(this.state.actionStatus);
                this.setState({ displayActionComment: false });
            } else {
                this.setState({ successMsg: "Saved Successfuly!" });
                window.scrollTo(0, 0);
                this.loadCommentDetails(prosSuppId);
            }
        }).catch(error => {
            this.setState({ errorMsg: error });
            window.scrollTo(0, 0);
        });
    }
    render() {
        return (
            <div>
                {this.state.render === true ?
                    <div>
                        <Header pageHeading="Prospective Supplier" />
                        <div className="container-fluid bg-light">
                            <Container className="bg-light">
                                <br />
                                <div className="row">
                                    <span className="col-sm-24">
                                        <span style={{ textAlign: 'center' }}><h3>John Deere Prospective Supplier Application Form</h3></span>
                                        <SuccessMsg message={this.state.successMsg} />
                                        <CompanyStatus status={this.state.companyInfo.status} headerComment={this.state.headerComment} deereView={true}/>
                                        <Card>
                                            <div className="card-body">
                                                {this.state.isSupplierServiceDown ?
                                                    <div><ServiceDownError /></div>
                                                    :
                                                    <CompanyTopHeader companyInfoObj={this.state.companyInfo} deereView={true} />
                                                }
                                            </div>
                                        </Card>
                                    </span>
                                </div>
                                <br/>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <Accordion>
                                            <AccordionItem title="Audits">
                                                {this.state.isAuditServiceDown ?
                                                    <div>
                                                        <h3 className="component-section-title">Audit</h3>
                                                        <ServiceDownError />
                                                    </div>
                                                    :
                                                    <AuditSummary auditInfoData={this.state.auditInfoJson} loginByDiv={this.state.loginBy} companyInfoObjDIV={this.state.companyInfo} loadAudit={this.loadSupplierAudits.bind(this)} />
                                                }
                                            </AccordionItem>
                                            <AccordionItem title="Comments">
                                                {this.state.isCommentServiceDown ?
                                                    <div>
                                                        <h3 className="component-section-title">Comments</h3>
                                                        <ServiceDownError />
                                                    </div>
                                                    :
                                                    <CommentComponent commentsInfoObj={this.state.commentsInfo} commentsCountObj={this.state.commentCount} saveComment={this.saveComments.bind(this)} status={this.state.companyInfo.status}
                                                    />
                                                }
                                            </AccordionItem>
                                        </Accordion>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="row">
                                            <div className="col-sm-24">
                                                <Accordion>
                                                    {this.state.companyInfo.country === "US" ?
                                                        <Accordion.Item id="DiversityAccordion" title="Supplier Diversity">
                                                            {this.state.isDiversityServiceDown ?
                                                                <div>
                                                                    <h3 className="component-section-title">Supplier Diversity</h3>
                                                                    <ServiceDownError />
                                                                </div>
                                                                :
                                                                <DiversitySummary diversityInfoData={this.state.diversityInfoJson} companyInfoObjDIV={this.state.companyInfo} />
                                                            }
                                                        </Accordion.Item>
                                                        : null
                                                    }
                                                    <Accordion.Item id="FinancialAccordion" title="Financial Information">
                                                        {this.state.isFinancialServiceDown ?
                                                            <div>
                                                                <h3 className="uxf-label">Finacial Information</h3>
                                                                <ServiceDownError />
                                                            </div>
                                                            :
                                                            <FinacialSummary finacialInfoData={this.state.finacialInfoJson} companyInfoObjFIN={this.state.companyInfo} />
                                                        }
                                                    </Accordion.Item>
                                                    <Accordion.Item id="CommoditiesAccordion" title="Commodities and Services">
                                                        {this.state.isCommodityServiceDown ?
                                                            <div>
                                                                <h3 className="uxf-label">Commodities and Services</h3>
                                                                <ServiceDownError />
                                                            </div>
                                                            : < CommoditiesSummary commoditiesInfoData={this.state.commoditiesInfoJson} companyInfoObjCOM={this.state.companyInfo} />
                                                        }
                                                    </Accordion.Item>
                                                </Accordion>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br/>
                                {(this.state.companyInfo.status === 'ASC' || this.state.companyInfo.status === 'URI' || this.state.companyInfo.status === 'URC' || this.state.companyInfo.status === 'AI' || this.state.companyInfo.status === 'H') ?
                                    <div className="row">
                                        <span className="col-md-24"  >
                                            <Card><br/>
                                                <div className="row">
                                                    <div className="col-md-12" style={{ paddingLeft: "30px" }}>
                                                        <Button type="secondary" action={this.handleNotInterest} title="Not Interested" />{" "}&nbsp;&nbsp;
                                                        {this.state.companyInfo.status !== 'H' ?
                                                            <Button type="secondary" action={this.handleOnHold} title="Application On Hold" />
                                                            :
                                                            null
                                                        }
                                                    </div>
                                                    <div className="col-md-12" style={{ textAlign: "right", paddingRight: "30px" }}>
                                                        <Button type="primary" action={this.handleStartSPR} title="Start Supplier Add" />{" "}
                                                    </div>
                                                </div>
                                                <br/>
                                            </Card>
                                        </span>
                                    </div>
                                    : null
                                }
                                <br/>
                            </Container>
                        </div>
                        <Footer />
                    </div>
                    : ""
                }
                <Modal show={this.state.displayActionComment}>
                    <Modal.Header>
                        <h5 className="modal-title">Comments</h5>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="uxf-alert-title">
                            <h6 style={{ fontWeight: 'normal' }}>These comments will be displayed to the prospective supplier.</h6>
                            <TextArea
                                name={"actionComment"}
                                placeholder={"Add Comment"}
                                rows={"4"}
                                cols={"500"}
                                value={this.state.actionComment}
                                handleChange={this.handleInput}
                                maxLength="4096"
                            />{" "}<span className="error">{this.state.actionCommentErrorMessage}</span>
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type="secondary btn-md" action={this.cancelActionComment} title={"Cancel"}/>&nbsp;&nbsp;<Button type="warning" action={this.saveActionComment} title={"Continue"}/>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}
export default Deeresummary;